export default {
  "content": "<path d=\"M15.85 12.8L18 14.725v1.5h-5.25v6.025L12 23l-.75-.75v-6.025H6v-1.5L8 12.8V4.5H6.75V3H17.1v1.5h-1.25v8.3zm-7.825 1.925h7.8L14.35 13.35V4.5H9.5v8.85l-1.475 1.375z\" fill=\"#70717A\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};